import { Component, Inject } from '@angular/core';
import { OauthService } from '../../services';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-outreach-scope-modal',
  templateUrl: './outreach-scope-modal.component.html',
  styleUrls: ['./outreach-scope-modal.component.scss'],
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatDialogModule,
    MatButtonModule
  ],
  standalone: true,
})
export class OutreachScopeModalComponent {
    public provider: 'Outreach' | 'Hubspot';
    public text: string;
    private isExport: boolean;

    constructor(
        private matDialogRef: MatDialogRef<OutreachScopeModalComponent>,
        private oauthService: OauthService,
        @Inject(MAT_DIALOG_DATA) private readonly data: any,
    ) {
            this.provider = this.data?.provider;
            this.text = this.data?.text;
            this.isExport = this.data?.isExport;
        }

    close() {
        this.matDialogRef.close();
    }

    proceed() {
        this.matDialogRef.close();
        this.oauthService[`relogin${this.provider}`](this.data?.attribute, this.isExport);
    }
}
